export default "/images/vendor/flag-icons/flags/4x3/sm.svg?42bdc9518f62841c35401d163ebed2b3";